export const PRODUCTS_ADMIN_DATA_FILTER_DATES= "PRODUCTS_ADMIN_DATA_FILTER_DATES"
export const LOCATIONS_ADMIN_DATA_FILTER_DATES= "LOCATIONS_ADMIN_DATA_FILTER_DATES"
export const SUBSCRIBERS_ADMIN_DATA_FILTER_DATES= "SUBSCRIBERS_ADMIN_DATA_FILTER_DATES"


export const DASHBOARD_ADMIN_DATA_FILTER_DATES= "DASHBOARD_ADMIN_DATA_FILTER_DATES"
 